export default __webpack_public_path__ + "static/media/KAZ.a64a49e6.svg";